//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'workOrderIndex',
    components: {},
    data() {
        var vm = this;
        return {
            columns: [
                {
                    title: '城市名称',
                    key: 'cityName',
                    align: 'center',
                    minWidth: 99,
                    fixed: 'left'
                },
                {
                    title: '项目名称',
                    key: 'projectName',
                    align: 'center',
                    minWidth: 120,
                    fixed: 'left'
                },
                {
                    title: '咨询工单',
                    align: 'center',
                    children: [
                        {
                            title: '未处理',
                            key: 'zxUntreatedCount',
                            align: 'center',
                            minWidth: 88,
                            render: (h, params) => {
                                const row = params.row;
                                const actions = [];
                                actions.push(h('a', {
                                    on: {
                                        click() {
                                            vm.showZx(row, 0);
                                        }
                                    }
                                }, row.zxUntreatedCount));
                                return h('div', actions);
                            }
                        },
                        {
                            title: '处理中',
                            key: 'zxInProcessingCount', minWidth: 88,
                            align: 'center',
                            render: (h, params) => {
                                const row = params.row;
                                const actions = [];
                                actions.push(h('a', {
                                    on: {
                                        click() {
                                            vm.showZx(row, 1);
                                        }
                                    }
                                }, row.zxInProcessingCount));
                                return h('div', actions);
                            }
                        },
                        {
                            title: '待回访',
                            align: 'center',
                            key: 'zxReturnVisitCount', minWidth: 88,
                            render: (h, params) => {
                                const row = params.row;
                                const actions = [];
                                actions.push(h('a', {
                                    on: {
                                        click() {
                                            vm.showZx(row, 2, false);
                                        }
                                    }
                                }, row.zxReturnVisitCount));
                                return h('div', actions);
                            }
                        },
                        {
                            title: '已处理',
                            align: 'center', minWidth: 88,
                            key: 'zxHandleCount'
                        },
                        {
                            title: '超时工单',
                            align: 'center', minWidth: 99,
                            key: 'zxOverTimeCount'
                            // minWidth: 99
                        }
                    ]

                },
                {
                    title: '投诉工单',
                    align: 'center',
                    children: [
                        {
                            title: '未处理', minWidth: 88,
                            key: 'tsUntreatedCount',
                            align: 'center',
                            render: (h, params) => {
                                const row = params.row;
                                const actions = [];
                                actions.push(h('a', {
                                    on: {
                                        click() {
                                            vm.showTs(row, 0);
                                        }
                                    }
                                }, row.tsUntreatedCount));
                                return h('div', actions);
                            }
                        },
                        {
                            title: '处理中', minWidth: 88,
                            key: 'tsInProcessingCount',
                            align: 'center',
                            render: (h, params) => {
                                const row = params.row;
                                const actions = [];
                                actions.push(h('a', {
                                    on: {
                                        click() {
                                            vm.showTs(row, 1);
                                        }
                                    }
                                }, row.tsInProcessingCount));
                                return h('div', actions);
                            }
                        },
                        {
                            title: '待回访', minWidth: 88,
                            align: 'center',
                            key: 'tsReturnVisitCount',
                            render: (h, params) => {
                                const row = params.row;
                                const actions = [];
                                actions.push(h('a', {
                                    on: {
                                        click() {
                                            vm.showTs(row, 2, false);
                                        }
                                    }
                                }, row.tsReturnVisitCount));
                                return h('div', actions);
                            }
                        },
                        {
                            title: '已处理', minWidth: 88,
                            align: 'center',
                            key: 'tsHandleCount'
                        },
                        {
                            title: '超时工单', minWidth: 99,
                            align: 'center',
                            key: 'tsOverTimeCount'
                            // minWidth: 88
                        }
                    ]
                },
                {
                    title: '报修工单',
                    align: 'center',
                    children: [
                        {
                            title: '未处理',
                            minWidth: 88,
                            key: 'bxUntreatedCount',
                            align: 'center',
                            render: (h, params) => {
                                const row = params.row;
                                const actions = [];
                                actions.push(h('a', {
                                    on: {
                                        click() {
                                            vm.showBx(row, 0);
                                        }
                                    }
                                }, row.bxUntreatedCount));
                                return h('div', actions);
                            }
                        },
                        {
                            title: '处理中',
                            minWidth: 88,
                            key: 'bxInProcessingCount',
                            align: 'center',
                            render: (h, params) => {
                                const row = params.row;
                                const actions = [];
                                actions.push(h('a', {
                                    on: {
                                        click() {
                                            vm.showBx(row, 1);
                                        }
                                    }
                                }, row.bxInProcessingCount));
                                return h('div', actions);
                            }
                        },
                        {
                            title: '待回访', minWidth: 88,
                            align: 'center',
                            key: 'bxReturnVisitCount',
                            render: (h, params) => {
                                const row = params.row;
                                const actions = [];
                                actions.push(h('a', {
                                    on: {
                                        click() {
                                            vm.showBx(row, 2, false);
                                        }
                                    }
                                }, row.bxReturnVisitCount));
                                return h('div', actions);
                            }
                        },
                        {
                            title: '已处理', minWidth: 88,
                            align: 'center',
                            key: 'bxHandleCount'
                        },
                        {
                            title: '超时工单', minWidth: 99,
                            align: 'center',
                            key: 'bxOverTimeCount'
                            // minWidth: 88
                        }
                    ]
                }
            ],
            list: [],
            loading: false
        };
    },
    computed: {},
    methods: {
        getProjectWorkOrdersCount() {
            this.loading = true;
            abp.ajax.get('/api/services/app/WorkOrder/GetProjectWorkOrdersCount').then(res => {
                this.list = [];
                this.list.push(...res.data.result);
            }).finally(() => {
                this.loading = false;
            });
        },
        showZx(row, status, isReturnVisit) {
            var s = {
                cityId: row.cityId,
                projectId: row.projectId,
                name: 'name1',
                status: status
            };
            if (isReturnVisit != undefined) {
                s.isReturnVisit = false;
            }
            // this.$store.commit('saveOrder/setSkuData', data);
            this.$store.commit('workOrder/setSearch', s);
            this.$router.push({ name: 'workOrderList' });
        },
        showTs(row, status, isReturnVisit) {
            var s = {
                cityId: row.cityId,
                projectId: row.projectId,
                name: 'name2',
                status: status
            };
            if (isReturnVisit != undefined) {
                s.isReturnVisit = false;
            }
            this.$store.commit('workOrder/setSearch', s);
            this.$router.push({ name: 'workOrderList' });
        },
        showBx(row, status, isReturnVisit) {
            var s = {
                cityId: row.cityId,
                projectId: row.projectId,
                name: 'name3',
                status: status
            };
            if (isReturnVisit != undefined) {
                s.isReturnVisit = false;
            }
            this.$store.commit('workOrder/setSearch', s);
            this.$router.push({ name: 'workOrderList' });
        },
        getCities() {
            this.$store.dispatch({
                type: 'city/getCityList'
            }).then(() => {
            });
        }
    },
    created() {
        this.getProjectWorkOrdersCount();
        this.getCities();
    }
};
